import API from "@src/constant/api";

import Request from '@src/util/request'

export default class AssureService {

	static getSMSCode(phone: string) {
		return Request.get(API.ASSURE_GETCODE, {phone})
	}

	static smsLogin(phone: string, code: string) {
		return Request.get(API.ASSURE_LOGIN_CODE, {phone, yzm: code})
	}

	static assureSubmit(data: any) {
		return Request.post(API.ASSURE_SUBMIT, data)
	}

	static getAssureDetail(id: string) {
		return Request.post(API.ASSURE_Detail, {loaningInfoId: id})
	}

	static getAreaList() {
		return Request.post(API.ASSURE_AREA)
	}

	/**
	 * 获取返利
	 */
	static getRebate() {
		return Request.get(API.API_REBATE)
	}

}